<template>
  <div class="jumbotron">
    <p class="lead">
      Sorry, but you are not authorized to access requested page. If you have additional questions, please contact IT-support.
    </p>
    <hr class="my-4">
  </div>
</template>

<script>
export default {
  name: 'InsufficientPermissionsPage'
}
</script>

<style scoped>
</style>
